import { useMutation, UseMutationOptions, useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import { ApiServiceErr, axiosApi } from "./apiService";
import { useGetStaticRecipeProcessTypes } from "./static-data";

export const useGetRecipeSpecificGenericProcess = (tenantId: string) =>
  useQuery(
    ["getRecipeSpecificGenericProcess", tenantId],
    async () => {
      const response = await axiosApi.get(`/recipe-specific-generic-process/${tenantId}`);
      return response?.data;
    },
    {
      refetchOnWindowFocus: false,
      enabled: !!tenantId
    }
  );

export const useCreateRecipeSpecificGenericProcess = (opt?: UseMutationOptions) =>
  useMutation<any, ApiServiceErr, any>(async data => {
    const response = await axiosApi.post(`/recipe-specific-generic-process`, data);
    return response?.data;
  }, opt);

export const useGetRecipeGenericProcessForCompany = (tenantId: string) => {
  const query = useGetRecipeSpecificGenericProcess(tenantId);
  const processTypes = useGetStaticRecipeProcessTypes();

  const data = useMemo(() => {
    if (query.data && processTypes.data) {
      return processGenericProcessData(query.data, processTypes.data);
    }
    return [];
  }, [query.data, processTypes.data]);

  return {
    ...query,
    data
  };
};

const processGenericProcessData = (data: any, staticProcessType: any) => {
  const currentAvailableData = data.reduce((acc: any[], item: any) => {
    const matchedStatic = staticProcessType.find((e: any) => e.key === item?.processId);
    if (matchedStatic) {
      acc.push({
        ...item,
        key: item?.processId,
        text: matchedStatic?.text,
        value: item?.processId
      });
    }
    return acc;
  }, []);

  return currentAvailableData;
};

export const useGetDownloadPdfUrl = (opt?: UseMutationOptions) =>
  useMutation<any, ApiServiceErr, any>(async data => {
    const response = await axiosApi.post(
      `/np-report-document/download?documentType=${data.documentType}`,
      data
    );
    return response?.data;
  }, opt);
